import { render, staticRenderFns } from "./NewDesign.vue?vue&type=template&id=39905a9c"
import script from "./NewDesign.vue?vue&type=script&lang=js"
export * from "./NewDesign.vue?vue&type=script&lang=js"
import style0 from "./NewDesign.vue?vue&type=style&index=0&id=39905a9c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports